import {PartnerPageShell} from "components/commons";
import {WealthyEnv} from "helpers";
import dynamic from "next/dynamic";
import React from "react";

const SipSwpPageContent = dynamic(() => import("components/Calculators/SipSwp"));

const SipSwpPage = ({seoData}) => (
  <PartnerPageShell seoData={seoData}>
    <SipSwpPageContent />
  </PartnerPageShell>
);

export async function getStaticProps() {
  const seoData = {
    title: "SIP + SWP Calculator for MFDs | Retirement Planning Calculator | Wealthy",
    description:
      "Use Wealthy's SIP + SWP Calculator to project retirement corpus, estimate systematic withdrawals and help clients plan with confidence.",
    keywords:
      "sip calculator, swp calculator, sip return calculator, sip mutual fund calculator, sip compounding calculator, sip top up calculator, sip amount calculator, swp return calculator, best swp calculator, sip and swp calculator, swp mutual fund calculator, swp lumpsum calculator, sip with swp calculator",
    canonicalUrl: `${WealthyEnv.URL}/partner/calculators/sip-swp`,
    ogImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/wealthy-og-image.jpg`,
    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: `${WealthyEnv.URL}`
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Calculators",
              item: `${WealthyEnv.URL}/partner/calculators`
            },
            {
              "@type": "ListItem",
              position: 3,
              name: "SIP + SWP Calculator",
              item: `${WealthyEnv.URL}/partner/calculators/sip-swp`
            }
          ]
        },
        {
          "@type": "FAQPage",
          mainEntity: [
            {
              "@type": "Question",
              name: "What is a SIP + SWP Calculator?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "A SIP + SWP Calculator combines a SIP calculator and an SWP calculator into a single retirement planning tool. It estimates how regular SIP investments can build a retirement corpus and projects how long that corpus may sustain systematic withdrawals after retirement."
              }
            },
            {
              "@type": "Question",
              name: "How does a SIP + SWP Calculator work?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "The calculator first estimates the retirement corpus using monthly SIPs, annual Step-ups and optional lump sum investments. It then uses this accumulated corpus to project regular withdrawals through an SWP while estimating the remaining corpus based on expected investment returns during retirement."
              }
            },
            {
              "@type": "Question",
              name: "Can I use the SIP + SWP Calculator for retirement planning?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "Yes. The calculator is specifically designed for retirement planning. It enables Mutual Fund Distributors to estimate retirement corpus, evaluate withdrawal sustainability and compare multiple retirement income strategies for their clients."
              }
            },
            {
              "@type": "Question",
              name: "Are the calculator results guaranteed?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "No. The calculator provides estimated projections based on the assumptions entered by the user. Actual investment returns, retirement corpus and withdrawal sustainability may differ depending on market performance, taxation, inflation, expenses and other factors. Mutual funds do not guarantee returns."
              }
            },
            {
              "@type": "Question",
              name: "Why should MFDs use a SIP + SWP Calculator?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "The calculator enables Mutual Fund Distributors to simplify retirement planning, compare multiple scenarios, improve client engagement and present complete financial plans using visual projections instead of manual calculations. It supports a more consultative, goal-based advisory approach."
              }
            }
          ]
        }
      ]
    }
  };

  return {
    props: {
      seoData
    }
  };
}

export default SipSwpPage;
